import React, { useState } from 'react';

import Select from '@/components/forms/Select';

import styles from './styles.module.scss';

interface Props {
  max?: number;
  onChange: (qty: number) => void;
}

const QtyField = ({ max, onChange }: Props) => {
  const [qty, setQty] = useState(1);

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const qtyVal = parseInt(e.target.value, 10);

    if (!isNaN(qtyVal)) {
      onChange(qtyVal);
      setQty(qtyVal);
    }
  };

  return (
    <div className={styles.qtyField} data-qty={qty}>
      <div>Qty</div>
      <Select
        name="qty"
        value={qty}
        options={Array.from(Array(max || 10), (_, i) => ({
          title: (i + 1).toString(),
          value: i + 1,
        }))}
        onChange={handleChange}
        required
      />
    </div>
  );
};

export default QtyField;
